import { InboxOutlined, PaperClipOutlined } from '@ant-design/icons'
import { Col, Descriptions, message, Row, Spin } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import Dragger from 'antd/lib/upload/Dragger'
import Axios from 'axios'
import React from 'react'

const Upload: React.FC = (props) => {
    const [state, setState] = React.useState({
        note: '',
        loading: false,
    })

    React.useEffect(() => {
        setState((prev) => ({ ...prev, loading: true }))
        Axios.get(`/note`)
            .then((res) => {
                setState((prev) => ({
                    ...prev,
                    note: res.data ? res.data.upload || '' : '',
                }))
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setState((prev) => ({ ...prev, loading: false }))
            })
    }, [])

    const opt = {
        name: 'file',
        multiple: false,
        customRequest: async (e: any) => {
            const formData = new FormData()
            formData.append('file', e.file, e.file.name)
            try {
                const res = await Axios.patch(`/devices`, formData, {
                    headers: {
                        'Content-Type': `multipart/form-data`,
                    },
                })
                e.onSuccess()
                downloadCsv(res.data)
            } catch (err) {
                console.error(err)
            }
        },
        onChange(info: any) {
            const { status } = info.file
            if (status !== 'uploading') {
                console.log(info.file, info.fileList)
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`)
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`)
            }
        },
    }

    const downloadCsv = (data: any) => {
        let csv = ''
        data.forEach(function (row: any) {
            csv += row.join(',')
            csv += '\n'
        })
        const hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = 'result.csv'
        hiddenElement.click()
    }

    return (
        <Row>
            <Col span={16}>
                <Dragger {...opt}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single or bulk upload. Strictly prohibit from uploading company data or other band
                        files
                    </p>
                </Dragger>

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <div>
                        <PaperClipOutlined />
                        <a href="/template/add.xlsx">Add Sensor To Lora.xlsx</a>
                    </div>
                    <div>
                        <PaperClipOutlined />
                        <a href="/template/add_onenet.xlsx">Add Sensor To Onenet.xlsx</a>
                    </div>
                    <div>
                        <PaperClipOutlined />
                        <a href="/template/remove.xlsx">Remove Platform Sensor.xlsx</a>
                    </div>
                </div>

                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <div>
                        <Descriptions title="Add to local or Add to platform" layout="horizontal" column={2} bordered>
                            <Descriptions.Item label="title">name of sensor</Descriptions.Item>
                            <Descriptions.Item label="deviceId">EUI / Device ID (as search key)</Descriptions.Item>
                            <Descriptions.Item label="district">sensor district</Descriptions.Item>
                            <Descriptions.Item label="latitude">latitude (for nb & local)</Descriptions.Item>
                            <Descriptions.Item label="longitude">longitude (for nb & local)</Descriptions.Item>
                            <Descriptions.Item label="installed">yes / no</Descriptions.Item>
                            <Descriptions.Item label="platform">lora / onenet</Descriptions.Item>
                            <Descriptions.Item label="action">
                                ADD / ADD_TO_PLATFORM / UPDATE / UPDATE_TO_PLATFORM / REMOVE / REMOVE_FROM_PLATFORM
                            </Descriptions.Item>
                            <Descriptions.Item label="hardwareId">Hardware ID (For LoRa)</Descriptions.Item>
                            <Descriptions.Item label="codec">
                                TMS01_NB02 / TMS01_NB03 / TMS01_LR01 / TMS01_LR02 / TMS01_LR03
                            </Descriptions.Item>
                            <Descriptions.Item label="phase">API Type (Refer to Setting)</Descriptions.Item>
                            <Descriptions.Item label="monitor">yes / no</Descriptions.Item>
                            <Descriptions.Item label="desc">Description (for nb)</Descriptions.Item>
                            <Descriptions.Item label="tags">Tags use , as delimiter (for nb)</Descriptions.Item>
                            <Descriptions.Item label="auth_info">(for nb)</Descriptions.Item>
                            <Descriptions.Item label="manufacturer">(for nb)</Descriptions.Item>
                            <Descriptions.Item label="version">(for nb)</Descriptions.Item>
                            <Descriptions.Item label="APP_EUI">Application EUI(for LoRa)</Descriptions.Item>
                            <Descriptions.Item label="APP_KEY">Application KEY(for LoRa)</Descriptions.Item>
                            <Descriptions.Item label="DEV_ADDR">(for LoRa)</Descriptions.Item>
                            <Descriptions.Item label="region">AS923(for LoRa)</Descriptions.Item>
                            <Descriptions.Item label="class">Class A / Class B / Class C(for LoRa)</Descriptions.Item>
                            <Descriptions.Item label="NWK_SKEY">(for LoRa)</Descriptions.Item>
                            <Descriptions.Item label="APP_SKEY">(for LoRa)</Descriptions.Item>
                        </Descriptions>
                    </div>
                </div>
            </Col>
            <Col span={8}>
                <Spin spinning={state.loading}>
                    <TextArea
                        rows={10}
                        value={state.note}
                        onPressEnter={(e) => {
                            Axios.post(`/note`, {
                                upload: state.note,
                            }).catch((err) => console.error(err))
                        }}
                        onChange={(e) => {
                            e.persist()
                            setState((prev) => ({ ...prev, note: e.target.value }))
                        }}
                    />
                </Spin>
            </Col>
        </Row>
    )
}

export default Upload
